import styled from 'styled-components';
import { propStyles } from '../styleHelper';
import styleFilter from '../styleFilter';

const Label = styled(styleFilter(styled.label``))`
  font-size: ${props => props.theme.fontSize.normal};
  color: ${props => props.theme.text.normal};
  ${propStyles}
`;

export default Label;
